import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TopBarLoaderComponent } from '../../molecules/top-bar/top-bar-loader/top-bar-loader.component';
import { NewstickerLoaderComponent } from '../../molecules/newsticker/newsticker-loader/newsticker-loader.component';
import { HomeStageLoaderComponent } from '../../organisms/home-stage/home-stage-loader/home-stage-loader.component';
import { TeaserContainerLoaderComponent } from '../../organisms/teaser-container/teaser-container-loader/teaser-container-loader.component';
import { HelpDisruptorLoaderComponent } from '../../organisms/help-disruptor/help-disruptor-loader/help-disruptor-loader.component';
import { CrossReferencingLoaderComponent } from '../../organisms/cross-referencing/cross-referencing-loader/cross-referencing-loader.component';
import { PrefooterLoaderComponent } from '../../organisms/prefooter/prefooter-loader/prefooter-loader.component';
import { FooterLoaderComponent } from '../../organisms/footer/footer-loader/footer-loader.component';
import { SectionComponent } from '../../organisms/section/section.component';

@Component({
  selector: 'hdi-page-loader',
  standalone: true,
  templateUrl: './page-loader.component.html',
  imports: [
    CommonModule,
    TopBarLoaderComponent,
    NewstickerLoaderComponent,
    HomeStageLoaderComponent,
    TeaserContainerLoaderComponent,
    HelpDisruptorLoaderComponent,
    CrossReferencingLoaderComponent,
    PrefooterLoaderComponent,
    FooterLoaderComponent,
    SectionComponent,
  ],
})
export class PageLoaderComponent {}
